import React from 'react';
import { FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";

export default function Ratingstar({ rating, size = 16, color = "#ffc107", showValue = false }) {
  const fullStars = Math.floor(rating || 0);
  const halfStar = (rating || 0) - fullStars >= 0.5 ? 1 : 0;
  const emptyStars = 5 - fullStars - halfStar;

  return (
    <div className="flex items-center gap-1">
      <div style={{ display: "flex", gap: "2px" }}>
        {[...Array(fullStars)].map((_, index) => (
          <FaStar key={`full-${index}`} color={color} size={size} />
        ))}
        {halfStar === 1 && <FaStarHalfAlt color={color} size={size} />}
        {[...Array(emptyStars > 0 ? emptyStars : 0)].map((_, index) => (
          <FaRegStar key={`empty-${index}`} color={color} size={size} />
        ))}
      </div>
      {showValue && (
        <span className="text-sm font-medium text-gray-700 ml-1">
          {Number(rating).toFixed(1)}
        </span>
      )}
    </div>
  );
}
